import React from 'react';
import jwt_decode from 'jwt-decode';
import "devextreme/data/odata/store";
import { createStore } from "devextreme-aspnet-data-nojquery";
import plusimg from "../../images/common/plus.png"
import exportimg from "../../images/common/xlsx.png"
import editimg from "../../images/common/pencil.png"
import onimg from "../../images/admin/on-button.png"
import offimg from "../../images/admin/off-button.png"
import history from "../history";
import {Form,Row,Modal,Button as ButtonBootstrap} from "react-bootstrap";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer, toast } from 'react-toastify';    
import 'react-toastify/dist/ReactToastify.css'; 
import '../../css/Buttons.css';
import CircleSign from '../ui/CircleSign';
import ConfirmDialog from './pages/customComponents/ConfirmDialog';
import {config} from '../../constants';
import {deleteKey} from '../../utils/exportMethods';
import { exportToExcel} from '../../utils/exportMethods';
import Maximize from '../ui/Maximize';
import Minimize from '../ui/Minimize';
import ConfirmationModal from '../ui/ConfirmationModal';
import CustomDataGrid from './pages/customComponents/CustomDataGrid';
import apiClient from '../../utils/apiClient';
import { handleErrorResponse } from '../../utils/apiClient';

const url = config.url.URL; //"http://localhost:52344";
const enableMsg = "Are you sure you want to enable this Agency Fee?";
const disableMsg = "Are you sure you want to disable this Agency Fee?";

const dataSource = createStore({
  key: "agencyFeesId",
  loadUrl: `${url}/AgencyFeesMicroservice`,
  insertUrl: `${url}/InsertOrder`,
  updateUrl: `${url}/UpdateOrder`,
  deleteUrl: `${url}/AgencyFeesMicroservice`,  
  onBeforeSend: (method, ajaxOptions) => {
     ajaxOptions.headers = {  
     'accept': 'application/json',
     'Authorization': 'Bearer '+localStorage.getItem('token')
  }  
   },
   onAjaxError: (e) => {
    const { xhr, error } = e;
    handleErrorResponse(error || { message: 'Unknown error occurred.', response: xhr });
  }
});

const exportAgencyFees = async (apiData, fileName) => {

  apiData.forEach(obj => {
    deleteKey(obj, 'agencyFeesId');
    deleteKey(obj, 'geoElementId');
    deleteKey(obj, 'buyingAgencyId');
    deleteKey(obj, 'mediaId');
    deleteKey(obj, 'subMediaId');
  });

  const headers = [
    { header: 'Year', key: 'year', width: 10, type: 'int' },
    { header: 'Country/Region', key: 'country', autoFit: true },
    { header: 'Agency', key: 'agency', autoFit: true },
    { header: 'Media', key: 'media', autoFit: true },
    { header: 'SubMedia', key: 'submedia', autoFit: true },
    { header: 'Fee (%)', key: 'fees', autoFit: true, type: 'float' },
    { header: 'Status', key: 'isEnabled', autoFit: true },
  ];

  await exportToExcel(headers, apiData, 'agency_fees_extract', 'Agency Fees Extract');
};

class AgencyFees extends React.Component {
    constructor(props) {
        super(props);
        this.applyFilterTypes = [{
          key: 'auto',
          name: 'Immediately'
        }, {
          key: 'onClick',
          name: 'On Button Click'
        }];
        
        this.state = {
          showFilterRow: true,
          showHeaderFilter: false,
          currentFilter: this.applyFilterTypes[0].key,
          showColumnLines: false,
          showRowLines: true,
          showBorders: true,
          showModal: false,
          showEditModal: false,
          showConfirmationModal: false,
          rowAlternationEnabled: true,
          fullscreen:false,
          Years: [],
          Countries: [],
          Agencies: [],
          allAgencies: [],
          Medias: [],
          SubMedias: [],
          validation:true,
          feesValidation: true,
          yearValidation: true,
          countryValidation: true,
          agencyValidation: true,
          mediaValidation: true,
          submediaValidation: true,
          editFeesValidation: true,
          oldCheckValue:false,
          feeValError: true,
          duplicatedValidation:true,
        };
        this.dataGrid = null;
        this.onShowFilterRowChanged = this.onShowFilterRowChanged.bind(this);
        this.onShowHeaderFilterChanged = this.onShowHeaderFilterChanged.bind(this);
        this.onCurrentFilterChanged = this.onCurrentFilterChanged.bind(this);
        this.confDiag = React.createRef();
      }

      fullscreenHandler=()=>{
        this.setState(prevState =>({fullscreen: !prevState.fullscreen}));
      }

      selectedChanged(e) {
        this.setState({
          selectedRowIndex: e.component.getRowIndexByKey(e.selectedRowKeys[0])
        });
      }
      showEditSuccessToast = () => {
        toast.success('Agency Fee has been updated');
      }
      showDisabledEnabledToast = (value) => {
        if(!this.confDiag.current.state.inEditMode) {
          if(!value) {
            toast.success('Agency Fee has been enabled');
          }
          else {
            toast.success('Agency Fee has been disabled');
          }
        }
        else {
          if(value) {
            toast.success('Agency Fee has been enabled');
          }
          else {
            toast.success('Agency Fee has been disabled');
          }
        }
      }

    openModal = () => {   
     this.setState({
       showModal: true,
       validation: true,
       feesValidation: true,
       yearValidation: true,
       countryValidation: true,
       agencyValidation: true,
       mediaValidation: true,
       submediaValidation: true,
       duplicatedValidation: true
     });
     this.state.Agencies = [];
     this.state.SubMedias = [];
    }

    handleClose = () =>{
      this.setState({ showConfirmationModal: true });
    }

    closeConfirmationModal = ()=>{
      this.setState({ showConfirmationModal: false });
    }

    doubleCloseModals = () => {
      const { state } = this.props.location;
      if (typeof state !== "undefined" && state != null) {
        if (state.showNewPopup) {
          history.push({ pathname: "/admin", state: { showNewPopup: false } });
        }
      }
      this.setState({
        showModal: false,
        showEditModal: false,
        showConfirmationModal: false,
      });
    };

    useRefresh = ()=>{
      this.dataGrid.useRefresh();
      this.setState({
        showModal: false,
        showEditModal: false,
        showConfirmationModal: false,
      });
    }
    
    handleEditClose = () =>{
        this.setState({ showConfirmationModal: true });
    }

    onCreateAgencyFee =()=>{
      
      if ((+this.refs.fees.value < 0 || +this.refs.fees.value > 100) || this.refs.fees.value == ""){
       this.setState({ feesValidation: false});
       }else {this.setState({ feesValidation: true})}

      if (this.refs.year.value == ""){
        this.setState({ yearValidation: false}); 
      } else {this.setState({ yearValidation: true})}

      if (this.refs.country.value == ""){
        this.setState({ countryValidation: false}); 
      } else {this.setState({ countryValidation: true})}

      if (this.refs.agency.value == ""){
        this.setState({ agencyValidation: false}); 
      } else {this.setState({ agencyValidation: true})}

      if (this.refs.media.value == ""){
        this.setState({ mediaValidation: false}); 
      } else {this.setState({ mediaValidation: true})}

      if (this.refs.submedia.value == ""){
        this.setState({ submediaValidation: false}); 
      } else {this.setState({ submediaValidation: true})}

      if (!((+this.refs.fees.value < 0 || +this.refs.fees.value > 100) || this.refs.fees.value == "") && this.refs.year.value !== "" && this.refs.country.value !== "" && this.refs.agency.value !== "" && this.refs.media.value !== "" && this.refs.submedia.value !== ""){

        this.setState({ validation: true}); 
        let AgencyFeeInfo = {
          FeesPercent: parseFloat(this.refs.fees.value),
          SubMediaId: this.refs.submedia.value,
          GeoElementId: this.refs.country.value,
          BuyingAgencyId: this.refs.agency.value,
          Year: parseInt(this.refs.year.value,10),
          IsEnabled: true
        };
        apiClient.post(`${url}/AgencyFeesMicroservice`,AgencyFeeInfo)
        .then(response => {
            const data = response.data;
            if (data) {
              if(data.statusCode ==400){
                this.setState({duplicatedValidation: false})
                return;
              }else{
                toast.success('Agency Fee has been created');
                this.doubleCloseModals();
                const { state } = this.props.location;
                if (typeof (state) !== 'undefined' && state != null) {
                    if (state.showNewPopup) {

                        history.push({ pathname: "/admin", state: { 'showNewPopup': false } });
                    }
                } else {
                  this.useRefresh();
                }
              }
          }
        });

      }else{
        this.setState({ validation: false}); 
        return;
      }
    }
    
  openEditModal = (e) => {         
    this.setState({showEditModal:true, editFeesValidation: true, feeValError: true});   
    console.log(e.row.data);
    this.setState({selectedRowIndex: e.row.data.agencyFeesId, selectedRowIndexForBuying: e.row.data.buyingAgencyId, oldCheckValue: e.row.data.isEnabled}); 
    this.refs.editfees.value = e.row.data.fees; 
    this.refs.chk_Is_Enabled.checked = e.row.data.isEnabled; 
  }

  onDeleteEnable = (e) => {
    this.confDiag.current.state.key = e.row.data.agencyFeesId;
    this.confDiag.current.state.status = e.row.data.isEnabled;
    this.confDiag.current.state.inEditMode = false;
    this.confDiag.current.handleChangeConfirmMessageAndOpenDialog(enableMsg); 
  }
  
  onDeleteDisable = (e) => {
    this.confDiag.current.state.key = e.row.data.agencyFeesId;
    this.confDiag.current.state.status = e.row.data.isEnabled;
    this.confDiag.current.state.inEditMode = false;
    this.confDiag.current.handleChangeConfirmMessageAndOpenDialog(disableMsg);
  }
  
  onEditAgencyFee = () => {

    if ((+this.refs.editfees.value < 0 || +this.refs.editfees.value > 100) || this.refs.editfees.value == "") {
      this.setState({ editFeesValidation: false });
      return;
    } else {
      this.setState({ editFeesValidation: true })

      const buyingAgencyStatus = this.state.allAgencies.find(
        (agency) => agency.buyingAgencyId === this.state.selectedRowIndexForBuying && agency.isEnabled
      );

      let AgencyFeeInfo = {
        AgencyFeesId: this.state.selectedRowIndex,
        FeesPercent: parseFloat(this.refs.editfees.value),
        IsEnabled: this.state.oldCheckValue
      };

      apiClient.put(`${url}/AgencyFeesMicroservice`, AgencyFeeInfo)
        .then(response => {
          const data = response.data;
          if (data) {
            if (this.refs.chk_Is_Enabled.checked != this.state.oldCheckValue) {
              if (
                !buyingAgencyStatus &&
                this.refs.chk_Is_Enabled.checked == true
              ) {
                this.setState({
                  feeValError: false,
                  editFeesValidation: false,
                });
              }
              this.confDiag.current.state.status = this.refs.chk_Is_Enabled.checked
              this.confDiag.current.state.inEditMode = true;
              this.confDiag.current.state.key = this.state.selectedRowIndex;
              this.confDiag.current.handleChangeConfirmMessageAndOpenDialog(
                this.refs.chk_Is_Enabled.checked ? enableMsg : disableMsg
              );
            }
            else {
              this.showEditSuccessToast();
              this.useRefresh();
            }
          }
        });
    }
  }

  onExportToExcel = () => {
    apiClient.get(`${url}/AgencyFeesMicroservice`)
      .then(response => {
        const data = response.data;
        if (data) {
          exportAgencyFees(data);
          toast.success('Agency Fees Excel export file has been generated')
        }
      });
  }

  fetchYears(){
    const year = (new Date()).getFullYear() -4;
    this.state.Years = Array.from(new Array(6),(val, index) => index + year);
  }

  fetchCountries() {
    let initialCountries = [];
    apiClient.get(`${url}/GeoElementMicroservice/countriesdropdown`)
      .then(response => {
        const data = response.data;
        initialCountries = data;
        this.setState({
          Countries: initialCountries,
        })
      }).catch((error) => {
        if (error === 'Unauthorized') {
          return; // Exit the componentDidMount function
        }
      });
  }

  fetchMedias() {
    let initialMedias = [];
    apiClient.get(`${url}/MediaMicroservice`)
      .then(response => {
        const data = response.data;
        initialMedias = data;
        this.setState({
          Medias: initialMedias,
        });
      }).catch((error) => {
        if (error === 'Unauthorized') {
          return; // Exit the componentDidMount function
        }
        console.error(error);
      });
  }

  fetchSubMedias(MediaId) {
    let initialSubMedias = [];
    apiClient.get(`${url}/SubmediaMicroservice/media/${MediaId}`, { headers: { 'Reference': `BudgetScreen`}})
      .then(response => {
        const data = response.data;
        initialSubMedias = data;
        this.setState({
          SubMedias: initialSubMedias,
        });
      }).catch((error) => {
        if (error === 'Unauthorized') {
          return; // Exit the componentDidMount function
        }
      });
  }

  fetchAgencies(CountryId) {
    let initialAgencies = [];
    apiClient.get(`${url}/BuyingAgencyMicroservice/country/${CountryId}`)
      .then(response => {
        const data = response.data;
        initialAgencies = data;
        this.setState({
          Agencies: initialAgencies,
        });
      });
  }

  fetchAllAgencies = () => {
    apiClient.get(`${url}/BuyingAgencyMicroservice`)
      .then(response => {
        const data = response.data;
        this.setState({ allAgencies: data });
      }).catch((error) => {
        if (error === 'Unauthorized') {
          return;
        }
      });
  }

  loadAgenciesByCountry = (event) => {
    console.log(event.target.value);
    if(event.target.value != ""){
      this.fetchAgencies(event.target.value);
    }else{
      this.setState({
        Agencies: [],
      });
    }
  };

  loadSubMediaByMedia = (event) => {
    console.log(event.target.value);
    if(event.target.value != ""){
      this.fetchSubMedias(event.target.value);
    }else{
      this.setState({
        SubMedias: [],
      });
    }
  };

  componentDidMount() {
    const decoded = jwt_decode(localStorage.getItem('token'));
    this.setState({
      can_export_to_excel: decoded.can_export_to_excel === "true"
    })
    const { state } = this.props.location;
    if (typeof(state) !== 'undefined' && state != null) {
    if(state.showNewPopup){
      this.setState({showModal:true});
    }
  }
    this.fetchYears();
    this.fetchCountries();
    this.fetchMedias();
    this.fetchAllAgencies();
  }

  handleChange = (event) => {}

  Checkisenabled = (e) =>{
    return e.row.data.isEnabled ;
  }

  Checkisdisabled = (e) =>{
    return !e.row.data.isEnabled ;
  }

  render() {

    let l_Years = this.state.Years;
    let optionYears = l_Years.map((year) =>
        <option value={year}>{year}</option>
    );

    let l_countries = this.state.Countries;
    let optionCountries = l_countries.map((country) =>
        <option value={country.geoElementId}>{country.name}</option>
    );

    let l_Medias = this.state.Medias;
    let optionMedias = l_Medias.map((media) =>
        <option value={media.mediaId}>{media.name}</option>
    );

    let l_Agencies = this.state.Agencies;
    let optionAgencies = l_Agencies.map((agency) =>
        <option value={agency.buyingAgencyId}>{agency.name}</option>
    );

    let l_SubMedias = this.state.SubMedias;
    let optionSubMedias = l_SubMedias.map((submedia) =>
        <option value={submedia.subMediaId}>{submedia.name}</option>
    );

    const columns = [
      { dataField: "isEnabled", caption: "Status", width: "110" },
      { dataField: "year", caption: "Year", width: "17%", alignment: "left" },
      { dataField: "country", caption: "Country/Region", width: "16%" },
      { dataField: "agency", caption: "Agency", width: "16%" },
      { dataField: "media", caption: "Media", width: "16%" },
      { dataField: "submedia", caption: "SubMedia", width: "16%" },
      { dataField: "fees", caption: "Fee (%)", width: "16%", alignment: "left" },
      // Add other columns specific to Profiles component
    ];

    const buttonColumn = [
      {text: "Edit", icon: editimg, className: "img-grid", name: "edit", onClick: this.openEditModal},
      {text: "btn_enabled", icon: onimg, hint: "Disable", visible: this.Checkisenabled, name: "delete", onClick: this.onDeleteDisable},
      {text: "btn_disabled", icon: offimg, hint: "Enable", visible: this.Checkisdisabled, name: "delete", onClick: this.onDeleteEnable},
      // Additional buttons for Profiles component
    ];

    return (
      
      <div className="div-body-section-details">
        <div className="div-body-section-details-header">
        <div className="div-section-title">
          <span>
            Agency Fees Management
          </span>
        </div>
        <div className="div-section-actions push">
          <button className={this.state.can_export_to_excel ? "btn-section-header" : "btn-section-header hidden" }  onClick={this.onExportToExcel}>
              <img className="img-section-header" src={exportimg} />
              <label>Export To Excel</label></button>
          <button  className="btn-section-header"  onClick={this.openModal}>
              <img className="img-section-header" src={plusimg} />
              <label>New Agency Fee</label>
          </button>
        </div>
        </div>
        <div  className="div-padding-20">

            <CustomDataGrid
              dataSource={dataSource}
              keyExpr="agencyFeesId"
              ref={(ref) => (this.dataGrid = ref)}
              rowAlternationEnabled={this.state.rowAlternationEnabled}
              onSelectionChanged={this.selectionChanged}
              showFilterRow={this.state.showFilterRow}
              currentFilter={this.state.currentFilter}
              showHeaderFilter={this.state.showHeaderFilter}
              columns={columns}
              buttonColumn={buttonColumn}
            />
      </div>

      <Modal show={this.state.showModal} onHide={this.handleClose} className="agency-fees" size="md" centered fullscreen={this.state.fullscreen}>
        <Modal.Header closeButton>
          <Modal.Title size="h6">New Agency Fee</Modal.Title>
          <button
            type="button"
            class="btn btn-primary admin-btn"
            onClick={this.fullscreenHandler}
          >
            {this.state.fullscreen ? <Maximize /> : <Minimize />}
          </button>
        </Modal.Header>

        <Modal.Body>  
        {!this.state.validation &&  this.state.duplicatedValidation && <Row style={{paddingLeft:"12px"}}><p className='mandatory-style-2'>Mandatory fields are missing. Saving of the User form is not allowed</p></Row>  }
        {!this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>This Agency Fee form already exists, your updates cannot be saved. Please go back to Agency Fees Management list to edit the corresponding form.</p></Row>  } 
          <Row>
            <Form.Group className="mb-3 col-md-12"  controlId="fees">
              <Form.Label className={`${this.state.feesValidation ? "normal-title" : "validation-title"} font-size-12`}>Fee (%)  <CircleSign/></Form.Label>
              <Form.Control className={`${!this.state.feesValidation && "validation-control"}`}  type="number" ref="fees" required placeholder="Fee" />
              {!this.state.feesValidation && <p className="p-required margin-0">The fee percentage must be between 0 and 100</p>}
            </Form.Group>
          </Row>
          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="year">
              <Form.Label className={`${this.state.yearValidation ? "normal-title" : "validation-title"} font-size-12`}>Year  <CircleSign/></Form.Label>   
              <Form.Control 
                className={`select-placeholder ${!this.state.yearValidation && "validation-control"}`}  
                placeholder="Year" 
                ref="year" 
                required 
                as="select"
                defaultValue="">
              <option value="" hidden>Year</option>
                {optionYears}
              </Form.Control>
              {!this.state.yearValidation && <p className="p-required margin-0">Required</p>}
            </Form.Group>
          </Row>
          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="country">
              <Form.Label className={`${this.state.countryValidation ? "normal-title" : "validation-title"} font-size-12`}>Country/Region  <CircleSign/></Form.Label>   
              <Form.Control 
                className={`select-placeholder ${!this.state.countryValidation && "validation-control"}`}  
                placeholder="Country/Region" 
                ref="country"
                as="select" 
                required
                defaultValue=""
                 onChange={this.loadAgenciesByCountry}>
              <option value="" hidden>Country/Region</option>
                {optionCountries}
              </Form.Control>
              {!this.state.countryValidation && <p className="p-required margin-0">Required</p>}
            </Form.Group>
          </Row>
          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="agency">
              <Form.Label className={`${this.state.agencyValidation ? "normal-title" : "validation-title"} font-size-12`}>Agency  <CircleSign/></Form.Label>   
              <Form.Control 
                className={`select-placeholder ${!this.state.agencyValidation && "validation-control"}`}  
                placeholder="Agency" 
                ref="agency" 
                as="select"
                required
                defaultValue=""
                >
              <option value="" hidden>Agency</option>
                {optionAgencies}
              </Form.Control>
              {!this.state.agencyValidation && <p className="p-required margin-0">Required</p>}
            </Form.Group>
          </Row> 
          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="media">
              <Form.Label className={`${this.state.mediaValidation ? "normal-title" : "validation-title"} font-size-12`}>Media  <CircleSign/></Form.Label>   
              <Form.Control 
                className={`select-placeholder ${!this.state.mediaValidation && "validation-control"}`}  
                placeholder="Media" 
                ref="media" 
                as="select" 
                required
                DefaultValue=""
                onChange={this.loadSubMediaByMedia}>
              <option value="" hidden>Media</option>
                {optionMedias}
              </Form.Control>
              {!this.state.mediaValidation && <p className="p-required margin-0">Required</p>}
            </Form.Group>
          </Row> 
          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="submedia">
              <Form.Label className={`${this.state.submediaValidation ? "normal-title" : "validation-title"} font-size-12`}>SubMedia  <CircleSign/></Form.Label>   
              <Form.Control 
                className={`select-placeholder  ${!this.state.submediaValidation && "validation-control"}`}  
                placeholder="Submedia" 
                ref="submedia" 
                as="select"
                required
                DefaultValue=""
                >
              <option value="" hidden>SubMedia</option>
                {optionSubMedias}
              </Form.Control>
              {!this.state.submediaValidation && <p className="p-required margin-0">Required</p>}
            </Form.Group>
          </Row> 
        </Modal.Body>
        <Modal.Footer>
        <ButtonBootstrap variant="primary" className='btnPrimary' onClick={this.onCreateAgencyFee}>
            Create Agency Fee
          </ButtonBootstrap>
          <ButtonBootstrap variant="secondary" className='btnSecondary' onClick={this.handleClose}>
            Cancel
          </ButtonBootstrap>
        </Modal.Footer>
      </Modal> 

      <Modal show={this.state.showEditModal} onHide={this.handleEditClose}  size="md" centered fullscreen={this.state.fullscreen}>
        <Modal.Header closeButton>
          <Modal.Title size="h6" >Edit Agency Fee</Modal.Title>
          <button
            type="button"
            class="btn btn-primary admin-btn"
            onClick={this.fullscreenHandler}
          >
            {this.state.fullscreen ? <Maximize /> : <Minimize />}
          </button>
        </Modal.Header>
        <Modal.Body>  
          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="fees">
              <Form.Label className={`${this.state.editFeesValidation ? "normal-title" : "validation-title"}`}>Fee (%)  <CircleSign/></Form.Label>
              <Form.Control className={`${!this.state.editFeesValidation && "validation-control"}`} type="number" ref="editfees" placeholder="Fees" required="required" />
              {!this.state.editFeesValidation && this.state.feeValError && <p className="p-required margin-0">The fee percentage must be between 0 and 100</p>}
              {!this.state.editFeesValidation && !this.state.feeValError && <p className="p-required">You can't enable this Agency Fee because it is linked to a disabled Agency. Please modify the Agency selected or go to Agencies administration to enable the current one.</p>}
            </Form.Group>
          </Row>
       
          <Row>
            <Form.Group className="mb-3" controlId="formBasicCheckbox">
              <Form.Check type="checkbox" ref="chk_Is_Enabled" label="Is Enabled" />
            </Form.Group>
          </Row>
        </Modal.Body>
        <Modal.Footer>
        <ButtonBootstrap variant="primary" className='btnPrimary' onClick={this.onEditAgencyFee}>
            Update Agency Fee
          </ButtonBootstrap>
          <ButtonBootstrap variant="secondary" className='btnSecondary' onClick={this.handleEditClose}>
            Cancel
          </ButtonBootstrap>
        </Modal.Footer>
      </Modal> 

      <ConfirmationModal show={this.state.showConfirmationModal} hide={this.closeConfirmationModal} doubleCloseModals={this.doubleCloseModals} msg="Your updates won't be saved. Are you sure you want to leave this page
          ?"/>

      <ConfirmDialog ref={this.confDiag} microserviceName="AgencyFeesMicroservice" editfunction={this.showDisabledEnabledToast} refreshfunction={this.useRefresh} title="Can't enable Agency Fee" msg="You can't enable this Agency Fee because it is linked to a disabled Agency. Please modify the agency selected or go to Agencies administration to enable the current one."></ConfirmDialog>

      <ToastContainer position="bottom-right"/>  
      </div>
    );
    }
    onShowFilterRowChanged(e) {
      this.setState({
        showFilterRow: e.value
      });
      this.clearFilter();
    }

    onShowHeaderFilterChanged(e) {
      this.setState({
        showHeaderFilter: e.value
      });
      this.clearFilter();
    }

    onCurrentFilterChanged(e) {
      this.setState({
        currentFilter: e.value
      });
    }

    clearFilter() {
      this.dataGrid.clearFilter();
    }
  }

export default AgencyFees;
